import { render, staticRenderFns } from "./WaIcon.vue?vue&type=template&id=ad7b8088&scoped=true&"
import script from "./WaIcon.vue?vue&type=script&lang=js&"
export * from "./WaIcon.vue?vue&type=script&lang=js&"
import style0 from "./WaIcon.vue?vue&type=style&index=0&id=ad7b8088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7b8088",
  null
  
)

export default component.exports